import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = "lUBYNEzVG5wnWQwnGh1SDEcQMEmE7";

export function encrypt(text) {
  return CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
}
